const PermissionLovFields = [
    {
        name: '权限组名称',
        code: 'name',
        column: true,
        defaultFilter: true,
        width: 250
    },
    {
        name: '说明',
        code: 'description',
        column: true,
        defaultFilter: true
    }
]
export default PermissionLovFields;